import React, { useRef } from 'react';

import { Form, message } from 'antd';
import { useTranslation } from 'react-i18next';
import {
  ALLOWED_FILE_ACCEPT,
  ALLOWED_FILE_TYPES,
} from '../../../helpers/constants';

const Uploader = ({ props }) => {
  const { names, handleFileUploaded } = props;
  const { t } = useTranslation();
  const inputRef = useRef(null);
  const onFileUpload = (e) => {
    const file = e.target.files[0];
    if (file && !ALLOWED_FILE_TYPES.includes(file.type)) {
      message.error({
        content: t('errors.invalidFileType'),
        duration: 2.5,
        className: 'card-message',
      });
      if (inputRef.current) {
        inputRef.current.value = '';
      }
      return;
    }
    handleFileUploaded(file);
  };

  return (
    <Form.Item name={names}>
      <div>
        <input
          ref={inputRef}
          className="input_container"
          type="file"
          accept={ALLOWED_FILE_ACCEPT}
          onChange={(e) => onFileUpload(e)}
        />
      </div>
    </Form.Item>
  );
};

export default Uploader;
